import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";
import React from "react";

function Layout({ children }) {
  const theme = useTheme().palette.mode;
  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: "1rem",
        minHeight: "5rem",
        marginTop: "2rem",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
}

export default Layout;
